var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M17.0615 17.0615C15.6425 18.1431 13.9147 18.7423 12.1308 18.7715C6.32025 18.7715 2.99994 12.1309 2.99994 12.1309C4.03247 10.2067 5.46455 8.52552 7.20014 7.20022M10.3876 5.68947C10.959 5.55573 11.544 5.48888 12.1308 5.49026C17.9413 5.49026 21.2617 12.1309 21.2617 12.1309C20.7578 13.0735 20.1569 13.961 19.4687 14.7788M13.8906 13.8906C13.6626 14.1353 13.3877 14.3315 13.0822 14.4677C12.7767 14.6038 12.447 14.6769 12.1126 14.6828C11.7782 14.6887 11.4461 14.6272 11.136 14.502C10.826 14.3767 10.5443 14.1903 10.3078 13.9539C10.0714 13.7174 9.88493 13.4357 9.75969 13.1256C9.63444 12.8156 9.57294 12.4834 9.57884 12.1491C9.58473 11.8147 9.65792 11.485 9.79403 11.1795C9.93013 10.874 10.1264 10.5991 10.371 10.3711",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M3 3L21.2617 21.2617",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/closedEye.7892c48ef7bc9619df0656f4ea236adf.svg";
export { ForwardRef as ReactComponent };